import React, { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
} from "@mui/material";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdatedOutlined";
import BrowserNotSupportedIcon from "@mui/icons-material/BrowserNotSupportedOutlined";
import { useDispatch, useSelector } from "react-redux";
import { updateBreakdownAnnouncementStatus } from "../../../store/actions/bplrt/equipmentAction";
import { useTranslation } from "react-i18next";
import parser from "html-react-parser";

const ActivateBreakdown = () => {
  const dispatch = useDispatch();
  const { breakdownAnnouncement } = useSelector((state) => state.bplrtEquip);

  const { t } = useTranslation("bplrtEquipment");

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      updateBreakdownAnnouncementStatus({
        announcements: breakdownAnnouncement,
        active: !breakdownAnnouncement.some(
          (announcement) => announcement.isActive === true
        ),
      })
    );

    handleClose();
  };

  return (
    <>
      {breakdownAnnouncement.some(
        (announcement) => announcement.isActive === true
      ) ? (
        <>
          <Button
            onClick={() => setOpen(true)}
            startIcon={<BrowserNotSupportedIcon fontSize="small" />}
            sx={{ boxShadow: 3 }}
            color="error"
            variant="contained"
          >
            {t("deactivateBtn")}
          </Button>

          <Dialog maxWidth="sm" open={open} onClose={handleClose}>
            <Box component="form" onSubmit={handleSubmit}>
              <DialogTitle>{t("breakdownConfirmDialogTitle")}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {parser(t("deactivateConfirmationHint"))}
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <Button onClick={handleClose} variant="outlined" fullWidth>
                  {t("cancelBtn")}
                </Button>
                <Button variant="contained" fullWidth type="submit">
                  {t("deactivateSubmitBtn")}
                </Button>
              </DialogActions>
            </Box>
          </Dialog>
        </>
      ) : (
        <>
          <Button
            onClick={() => setOpen(true)}
            startIcon={<BrowserUpdatedIcon fontSize="small" />}
            variant="outlined"
          >
            <strong>{t("activateBtn")}</strong>
          </Button>

          <Dialog open={open} onClick={handleClose} maxWidth="sm">
            <Box component="form" onSubmit={handleSubmit}>
              <DialogTitle>{t("breakdownConfirmDialogTitle")}</DialogTitle>

              <DialogContent>
                <DialogContentText>
                  {parser(t("activateConfirmationHint"))}
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <Button onClick={handleClose} fullWidth variant="outlined">
                  {t("cancelBtn")}
                </Button>

                <Button type="submit" fullWidth variant="contained">
                  {t("activateSubmitBtn")}
                </Button>
              </DialogActions>
            </Box>
          </Dialog>
        </>
      )}
    </>
  );
};

export default ActivateBreakdown;
